import { render, staticRenderFns } from "./machineryContractMag.vue?vue&type=template&id=61d18db6&scoped=true&"
import script from "./machineryContractMag.vue?vue&type=script&lang=js&"
export * from "./machineryContractMag.vue?vue&type=script&lang=js&"
import style0 from "./machineryContractMag.vue?vue&type=style&index=0&id=61d18db6&scoped=true&lang=css&"
import style1 from "./machineryContractMag.vue?vue&type=style&index=1&id=61d18db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d18db6",
  null
  
)

export default component.exports